import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Grid, Input, Dropdown} from 'semantic-ui-react';
import {noTimeZoneShortISODate, dateFormatPicker} from '../../../common/constants/datesFormat';
import {parseDealers, parseAgencies, parseUsers} from '../../../common/util/options';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {reasonsOptions} from '../../../common/constants/lists';
import {Actions} from '../../../common/actions';

class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'isDealerAdmin': hasAccessPermission(props.permissions, resources.DealerLostSalesReport, scopes.PartialSee),
    };
    this.changeEndDate = this.changeEndDate.bind(this);
    this.changeStartDate = this.changeStartDate.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.handleDealerChange = this.handleDealerChange.bind(this);
    this.handleAgencyChange = this.handleAgencyChange.bind(this);
  }

  handleFilterChange(event, data) {
    this.props.updateLostSalesReportFilters({[data.name]: data.value.toUpperCase()});
  }

  handleOptionChange(event, data) {
    this.props.updateLostSalesReportFilters({[data.name]: data.value});
  }

  handleDealerChange(event, data) {
    this.props.updateLostSalesReportFilters({'agency': '', 'user': '', [data.name]: data.value});
  }

  handleAgencyChange(event, data) {
    this.props.updateLostSalesReportFilters({'user': '', [data.name]: data.value});
  }

  changeStartDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);
    const {initialDate, finalDate} = this.props;

    if (dateFormatted === initialDate) {
      return;
    }

    if (!finalDate || (finalDate && moment(date) > moment(finalDate))) {
      this.props.updateLostSalesReportFilters({'finalDate': dateFormatted});
    }

    this.props.updateLostSalesReportFilters({'initialDate': dateFormatted});
  }

  changeEndDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    if (dateFormatted === this.props.endDateFilter) {
      return;
    }

    this.props.updateLostSalesReportFilters({'finalDate': dateFormatted});
  }

  renderDealerFilters() {
    const {loading, loadingAgencies, loadingUsers, users, dealers, dealer, agency, user} = this.props;

    if (!this.props.isUserFromTDE) {
      return (
        <Grid.Row columns={4} stretched textAlign='left'>
          <Grid.Column>
            <label><strong>Usuario</strong></label>
            <Dropdown fluid search selection
              name='user'
              value={user}
              options={parseUsers(users, dealer, agency)}
              disabled={loading || loadingUsers || loadingAgencies}
              onChange={this.handleOptionChange}
            />
          </Grid.Column>
          {this.renderAgencyFilter()}
        </Grid.Row>
      );
    }

    return (
      <Grid.Row columns={4} stretched textAlign='left'>
        <Grid.Column>
          <label><strong>Concesionario</strong></label>
          <Dropdown fluid selection
            name='dealer'
            value={dealer}
            options={parseDealers(dealers)}
            disabled={loading || loadingAgencies}
            onChange={this.handleDealerChange}
          />
        </Grid.Column>
        {this.renderAgencyFilter()}
        <Grid.Column>
          <label><strong>Usuario</strong></label>
          <Dropdown fluid search selection
            name='user'
            value={user}
            options={parseUsers(users, dealer, agency)}
            disabled={loading || loadingUsers || !dealer || !agency}
            onChange={this.handleFilterChange}
          />
        </Grid.Column>
      </Grid.Row>
    );
  }

  renderAgencyFilter() {
    const {isDealerAdmin} = this.state;
    const {isUserFromTDE, dealer, agency, agencies, loadingAgencies, loading} = this.props;
    
    if (!isUserFromTDE && !isDealerAdmin) {
      return null;
    }

    return (
      <Grid.Column>
        <label><strong>Agencia</strong></label>
        <Dropdown fluid selection
          name='agency'
          value={agency}
          options={parseAgencies(agencies, dealer)}
          disabled={loading || loadingAgencies || !dealer}
          onChange={this.handleAgencyChange}
        />
      </Grid.Column>
    );
  }

  render() {
    const {loading, initialDate, finalDate, partCode, reason} = this.props;

    return (
      <React.Fragment>
        <Grid.Row columns={4} stretched textAlign='left'>
          <Grid.Column>
            <label><strong>Fecha Inicio</strong></label>
            <DatePicker
              locale='es'
              placeholderText='Fecha Inicio'
              customInput={<Input icon='calendar' size='small' />}
              dateFormat={dateFormatPicker}
              selected={initialDate ? moment(initialDate, noTimeZoneShortISODate).toDate() : null}
              onChange={this.changeStartDate}
              disabled={loading}
              maxDate={moment().endOf('year').toDate()}
            />
          </Grid.Column>
          <Grid.Column>
            <label><strong>Fecha Fin</strong></label>
            <DatePicker
              locale='es'
              customInput={<Input icon='calendar' size='small' />}
              dateFormat={dateFormatPicker}
              selected={finalDate ? moment(finalDate, noTimeZoneShortISODate).toDate() : null}
              onChange={this.changeEndDate}
              disabled={!initialDate || loading}
              minDate={moment(initialDate).toDate()}
              placeholderText='Fecha Fin'
            />
          </Grid.Column>
          <Grid.Column>
            <label><strong>Motivo</strong></label>
            <Dropdown search selection
              name='reason'
              options={reasonsOptions}
              value={reason}
              disabled={loading}
              onChange={this.handleOptionChange}
              placeholder='Seleccionar'
            />
          </Grid.Column>
          <Grid.Column>
            <label><strong>Código</strong></label>
            <Input fluid
              name='partCode'
              maxLength='20'
              value={partCode}
              disabled={loading}
              onChange={this.handleFilterChange}
              placeholder='Código del repuesto'
            />
          </Grid.Column>
        </Grid.Row>
        {this.renderDealerFilters()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const {loading, loadingAgencies, agencies, list} = state.dealer;
  const {downloading, 'loading': loadingReport} = state.lostSalesReportDetail;

  return {
    'permissions': state.session.permissions,
    'isUserFromTDE': state.session.isUserFromTDE,
    'loadingAgencies': loading || loadingAgencies,
    'loadingUsers': state.users.loading,
    'loading': loadingReport || downloading,
    'dealers': list,
    'agencies': agencies,
    'users': state.users.list,
    'initialDate': state.lostSalesReportDetail.initialDate,
    'finalDate': state.lostSalesReportDetail.finalDate,
    'dealer': state.lostSalesReportDetail.dealer,
    'agency': state.lostSalesReportDetail.agency,
    'user': state.lostSalesReportDetail.user,
    'reason': state.lostSalesReportDetail.reason,
    'partCode': state.lostSalesReportDetail.partCode,
  };
};

const {updateLostSalesReportFilters} = Actions;

export default connect(mapStateToProps, {updateLostSalesReportFilters})(Filters);
